import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import { PrimaryButtonLabel } from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import RelativeContainer from 'packages/kakapo-ui-kit/components/atoms/RelativeContainer';
import { PlainHorizontalCardPadding } from 'packages/kakapo-ui-kit/components/cards/PlainHorizontalCard';

interface IProps {
	isDragging: boolean;
	accept: Array<string>;
	inputRef: React.RefObject<HTMLInputElement>;
	translationPropertyKey: string;

	paddingSize?: PlainHorizontalCardPadding;

	onSelectFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const HiddenFullSizeInput = styled.input`
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	position: absolute;
	opacity: 0;
`;

interface IElementProps {
	isDragging: boolean;
}

const Element = styled.div<IElementProps>`
	border: 2px dashed ${(props) => props.theme.colors.primary};
	border-radius: 6px;
	position: relative;

	${(props) =>
		props.isDragging
			? `
		border-style: solid;
	`
			: ''}
`;

const Overlay = styled.div`
	border-radius: 6px;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	position: absolute;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: none;
	background-color: ${(props) => props.theme.colors.primary};
`;
export default function ImageUploadDropZone({
	accept,
	isDragging,
	inputRef,
	onSelectFile,
	translationPropertyKey,
	paddingSize,
}: IProps) {
	const { t } = useTranslation();

	return (
		<Element isDragging={isDragging}>
			<Column
				p={paddingSize === PlainHorizontalCardPadding.Small ? [1, 2, 3] : [3, 4, 5]}
				textAlign="center"
			>
				<HiddenFullSizeInput
					type="file"
					accept={accept.join(', ')}
					ref={inputRef}
					id="ImageUploadDropZoneInput"
					onChange={onSelectFile}
				/>

				{isDragging && (
					<Overlay>
						<SectionTitle color="white">{t('common.forms.file-upload.letGoToUpload')}</SectionTitle>
					</Overlay>
				)}

				<Column>
					<SectionTitle color="primary">{t('common.forms.file-upload.dropHere')}</SectionTitle>
				</Column>

				<Column mt={3}>
					<SectionTitle color="antracite">{t('common.or')}</SectionTitle>
				</Column>

				<Column mt={3}>
					<RelativeContainer sendToTop={isDragging !== true}>
						<PrimaryButtonLabel htmlFor="ImageUploadDropZoneInput">
							{t(`common.forms.file-upload.${translationPropertyKey}.browse`)}
						</PrimaryButtonLabel>
					</RelativeContainer>
				</Column>

				<Column mt={3}>
					<ParagraphSmall color="slateBlue">
						{t(`common.forms.file-upload.${translationPropertyKey}.supportedImages`)}
					</ParagraphSmall>
				</Column>
			</Column>
		</Element>
	);
}
